import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
const problems = ['Perdés tiempo valioso buscando material que casi nunca tiene ejemplos argentinos', 'Tus alumnos se desconectan porque los casos no tienen nada que ver con Argentina', 'No podés conectar la Criminalística con la actualidad: Vucetich, el BNDG, el EAAF, los protocolos 2026, la evidencia digital', 'Tus evaluaciones son siempre las mismas porque no tenés un banco de casos y ejercicios técnicos actualizados', 'Llegás al inicio del ciclo lectivo sin una secuencia didáctica completa lista para usar', 'Cuando surge el debate IA-justicia o deepfakes-evidencia no tenés datos técnicos reales para fundamentar el relato'];
export function ProblemSection() {
  return <section className="py-20 bg-navy-950" data-id="element-275" data-mp="1p214omcnsoev">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-276" data-mp="1p2u1auhwlxja">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-277" data-mp="1k2y0130lck7f">
          <h2 className="md:text-4xl font-extrabold text-white mb-6 text-balance text-[20px]" data-id="element-278" data-mp="sc8lbs3o812j">
            ❓ ¿Cuántas clases más vas a preparar sobre Criminalística sin tener el
            material correcto?
          </h2>

          <div className="space-y-6 text-lg text-silver text-left md:text-center max-w-3xl mx-auto" data-id="element-279" data-mp="125pectvzhc55">
            <p className="text-[14px]" data-id="element-280" data-mp="174itsrutzd7y">
              Buscás información en internet que no tiene secuencia didáctica ni
              menciona Argentina. Armás planificaciones desde cero cada ciclo
              lectivo. Y cuando un alumno pregunta sobre el sistema Vucetich, por
              qué Argentina fue el primer país en resolver un caso judicial con
              huellas dactilares, qué dice el Protocolo 485/2024 sobre evidencia
              digital o cómo funciona el AFIS del RENAPER con 40 millones de
              perfiles, no tenés una respuesta que los enganche con la realidad
              del país.
            </p>
            <p data-id="element-281" data-mp="y1778fwrzs0a">
              <strong className="text-white text-[16px]" data-id="element-282" data-mp="y208j1cytpb1">
                No es falta de vocación docente. Es que nadie armó el sistema
                completo para vos.
              </strong>
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-navy-800/60 border border-silver/20 rounded-2xl p-6 md:p-8" data-id="element-283" data-mp="17ws45zmzm236">
          <h3 className="text-xl font-bold text-silver-light mb-6 text-center" data-id="element-284" data-mp="1lqt6t4h2898t">
            😓 ESTO TE ESTÁ PASANDO AHORA MISMO
          </h3>
          <ul className="space-y-4" data-id="element-285" data-mp="25dmi4j19ysz3">
            {problems.map(problem => <li key={problem} className="flex items-start gap-3" data-id="element-286" data-mp="2aad05bwn3yn5">
                <div className="mt-1 bg-silver/15 p-1 rounded-full shrink-0 border border-silver/30" data-id="element-287" data-mp="1wbwuloaike6l">
                  <XIcon className="w-4 h-4 text-silver-light" data-id="element-288" data-mp="20cyl9gqd7hwy" />
                </div>
                <span className="text-silver-light font-medium text-[14px]" data-id="element-289" data-mp="1mlts8xhi5nvl">
                  {problem}
                </span>
              </li>)}
          </ul>
        </motion.div>

        <div className="text-center mt-12" data-id="element-290" data-mp="1red7rzzr2t31">
          <p className="font-bold text-silver text-[16px]" data-id="element-291" data-mp="1cop44s43jic5">
            ¿Y si esta fuera la última semana que enseñás Criminalística sin tener
            todo resuelto?
          </p>
        </div>
      </div>
    </section>;
}